import axios from 'axios';
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';
import { localStorageService } from './localStorage.service';
import { requestWithStatusHandling } from './api-status-handler';

export const getSupplier = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SAMPLES.GET_SUPPLIER}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getMainSamples = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SAMPLES.GET_MAIN_SAMPLES}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const saveBulkTrackingdates = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SAMPLES.BULK_DATES_UPLOAD}`, {
      data,
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getOtherSamples = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SAMPLES.GET_OTHER_SAMPLES}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getOrderSamples = async (devOrderId, query) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SAMPLES.GET_SAMPLES}`, {
      params: { ...query, devOrderId },
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getSingleSample = async (obj) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SAMPLES.GET_SAMPLES_BY_ID}${obj.sampleId}`, { params: { devOrderId: obj.devOrderId } });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const submitAddEditSampleForm = async (data) => {
  try {
    return requestWithStatusHandling(apiClient, {
      method: 'post',
      url: `${apiEndpoint}${API.SAMPLES.ADD_SAMPLE}`,
      data: { ...data },
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const submitEditSampleForm = async (data) => {
  try {
    return requestWithStatusHandling(apiClient, {
      method: 'put',
      url: `${apiEndpoint}${API.SAMPLES.EDIT_SAMPLE}${data.sampleId}`,
      data,
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const updateSampleTrackingDates = async (data) => {
  try {
    return requestWithStatusHandling(apiClient, {
      method: 'patch',
      url: `${apiEndpoint}${API.SAMPLES.EDIT_SAMPLE}${data.sampleId}/tracking-dates`,
      data,
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const updateSamplePriority = async (devOrderId, sampleId, priority) => {
  try {
    return await requestWithStatusHandling(apiClient, {
      method: 'put',
      url: `${apiEndpoint}${API.SAMPLES.UPDATE_SAMPLE_PRIORITY}/${sampleId}/priority`,
      data: { priority: priority ?? null },
      params: { devOrderId },
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

/**
 * Bulk-updates the priority of multiple samples in a single request.
 * @param {string[]} sampleIds - Identifiers of the samples to update.
 * @param {string|null} priority - The priority to apply (null clears it).
 * @returns {Promise<object>} The API response.
 */
export const bulkUpdateSamplePriority = async (sampleIds, priority) =>
  requestWithStatusHandling(apiClient, {
    method: 'put',
    url: `${apiEndpoint}${API.SAMPLES.BULK_UPDATE_SAMPLE_PRIORITY}`,
    data: { sampleIds, priority: priority ?? null },
  });

/**
 * Bulk-updates the status of multiple samples in a single request.
 * @param {string[]} sampleIds - Identifiers of the samples to update.
 * @param {string} status - The status to apply.
 * @returns {Promise<object>} The API response.
 */
export const bulkUpdateSampleStatus = async (sampleIds, status) =>
  requestWithStatusHandling(apiClient, {
    method: 'put',
    url: `${apiEndpoint}${API.SAMPLES.BULK_UPDATE_SAMPLE_STATUS}`,
    data: { sampleIds, status },
  });

export const uploadCommentImg = async (obj) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SAMPLES.UPLOAD_IMG}`, obj);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const deleteSamples = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SAMPLES.DELETE_SAMPLES}`, { data: { ...data } });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const submitSampleTrackingForm = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SAMPLES.ADD_SAMPLE_TRACKING}`, data);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const deleteSample = async (id) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SAMPLES.DELETE_SAMPLES}`, { params: id });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getLegLength = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.FETCH_LENGTHS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getColourWays = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.FETCH_COLOURS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getSizes = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.FETCH_SIZES}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const setSamplesPermission = async (param, data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SAMPLES.SET_SAMPLES_PERMISSION}`, data, {
      params: { ...param },
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getSamplesPermission = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SAMPLES.GET_SAMPLES_PERMISSION}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const setSamplesAnnotationsImage = async (param, data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SAMPLES.SAMPLE_ANNOTATIONS}/${param.devOrderId}/${param.sampleId}`, data);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const replaceSamplesImage = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SAMPLES.REPLACE_SAMPLE_IMAGE}`, data);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getSamplesAnnotationsImage = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SAMPLES.SAMPLE_ANNOTATIONS}/${data.devOrderId}/${data.sampleId}`);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const saveSamplesAnnotationsImage = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SAMPLES.SAVE_SAMPLE_ANNOTATIONS}`, data);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const deleteSamplesAnnotation = async (devOrderId, sampleId, data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SAMPLES.SAMPLE_ANNOTATIONS}/${devOrderId}/${sampleId}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const submitSampleImages = async (param, data, sampleId) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SAMPLES.SAVE_SAMPLE_IMAGES}/${sampleId}/photos`, data, {
      params: { ...param },
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getSamplesImage = async (sampleId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SAMPLES.SAVE_SAMPLE_IMAGES}/${sampleId}`);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getSamplesDetails = async (sampleId, data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SAMPLES.GET_SAMPLES}/${sampleId}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getSampleDropdownOptions = async (devOrderId, sampleId) => {
  try {
    const params = { devOrderId };
    if (sampleId) {
      params.sampleId = sampleId;
    }
    return await apiClient.get(`${apiEndpoint}${API.SAMPLES.GET_SAMPLE_DROPDOWN_OPTIONS}`, {
      params,
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getSampleVersionList = async (devOrderId, sampleId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SAMPLES.GET_SAMPLE_VERSION_LIST}`, {
      params: { devOrderId, sampleId },
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getSamplesMissingComponent = async (devOrderId, data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SAMPLES.MISSING_COMPONENT}/${devOrderId}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const submitSampleMissingComponent = async (param) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SAMPLES.MISSING_COMPONENT_SAVE}`, { ...param });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const saveCommentService = async (param) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SAMPLES.ADD_COMMENT}`, {
      ...param,
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getSampleComments = async (obj) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SAMPLES.GET_COMMENTS}/${obj.smapleId}`, {
      params: Intl.DateTimeFormat().resolvedOptions(),
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const editComment = async (obj) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SAMPLES.GET_SINGLE_COMMENT}/${obj._id}`);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const updateComment = async (obj) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SAMPLES.UPDATE_COMMENT}/${obj._id}`, { ...obj });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const commentReaded = async (obj) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SAMPLES.COMMENT_READ}/${obj.id}`, { ...obj });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getSampleTraking = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SAMPLES.SAMPLE_TRAKING}`);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const saveSampleTabDataService = async (data, params) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SAMPLES.SAMPLE_ACTIVETAB_ADD_DATA}/${params?.sampleId}/${params?.section}`, data, {
      params: { ...params },
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const saveSamplesSpecificationData = async (sampleId, params, payLoad) => {
  return requestWithStatusHandling(apiClient, {
    method: 'put',
    url: `${apiEndpoint}${API.SAMPLES.EDIT_SAMPLE_SPECIFICATIONS}/${sampleId}`,
    data: payLoad,
    params: { ...params },
  });
};

export const saveSamplesSpecificationDataMulti = async (sampleId, params, payLoad) => {
  return requestWithStatusHandling(apiClient, {
    method: 'put',
    url: `${apiEndpoint}${API.SAMPLES.EDIT_SAMPLE_SPECIFICATIONS_MULTI}/${sampleId}`,
    data: payLoad,
    params: { ...params },
  });
};

export const saveSupplierCommentsService = async (sampleId, params, payLoad) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SAMPLES.SAVE_SPECIFICATION_SUPPLIER_COMMENT}/${sampleId}/${params.supplierId}`, payLoad, {
      params: { ...params },
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const saveSupplierCommentsServiceMulti = async (sampleId, params, payLoad) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SAMPLES.SAVE_SPECIFICATION_SUPPLIER_COMMENT_MULTI}/${sampleId}`, payLoad, {
      params: { ...params },
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const replaceSupplierImage = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SAMPLES.REPLACE_SUPPLIER_IMAGE}`, data);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getSampleMeasurementsByGradingGroup = async (data) => {
  return requestWithStatusHandling(apiClient, {
    method: 'get',
    url: `${apiEndpoint}${API.SAMPLES.GRADING_GROUP_MEASUREMENTS}`,
    params: { ...data },
  });
};

export const searchGradingGroupPoms = async (params) => {
  return requestWithStatusHandling(apiClient, {
    method: 'get',
    url: `${apiEndpoint}${API.SAMPLE_ORDERS.GRADING_GROUP_POMS}`,
    params,
  });
};

export const importPomToSampleSpec = async (params) => {
  return requestWithStatusHandling(apiClient, {
    method: 'post',
    url: `${apiEndpoint}${API.SAMPLE_ORDERS.IMPORT_POM_TO_SPEC}`,
    data: params,
  });
};

export const addManualPomToSampleSpec = async (params) => {
  return requestWithStatusHandling(apiClient, {
    method: 'post',
    url: `${apiEndpoint}${API.SAMPLE_ORDERS.ADD_MANUAL_POM_TO_SPEC}`,
    data: params,
  });
};

export const deletePomFromSampleSpec = async (params) => {
  return requestWithStatusHandling(apiClient, {
    method: 'delete',
    url: `${apiEndpoint}${API.SAMPLE_ORDERS.DELETE_POM_FROM_SPEC}`,
    params,
  });
};

export const reorderSpecPomSequence = async (data) => {
  return requestWithStatusHandling(apiClient, {
    method: 'put',
    url: `${apiEndpoint}${API.SAMPLE_ORDERS.REORDER_POM_SEQUENCE}`,
    data,
  });
};

export const getSamplePaginationWiseService = async (devOrderId, query) => {
  try {
    return requestWithStatusHandling(apiClient, {
      method: 'get',
      url: `${apiEndpoint}${API.SAMPLES.GET_PAGINATION_SAMPLES}`,
      params: { ...query, devOrderId },
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const exportExcelService = async (data) => {
  try {
    data.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const userInfo = localStorageService.get('loggedInUserInfo');
    if (userInfo) {
      const config = {
        headers: { Authorization: `Bearer ${userInfo.token}` },
        responseType: 'arraybuffer',
        params: { ...data },
      };
      return new Promise((resolve, reject) => {
        axios
          .get(`${apiEndpoint}${API.SAMPLES.SAMPLES_LIST_EXPORT_EXCEL}`, {
            ...config,
            withCredentials: true,
          })
          .then((response) => {
            const blob = new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            resolve({ blob, headers: response.headers });
          })
          .catch(function (error) {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};
